import { Modal } from 'components/molecules/Modal'
import type { NotVerifiedModalProps } from './types'
import { closeModal } from 'lib/utils'

export const NotVerifiedModal = ({ title, text }: NotVerifiedModalProps) => {
  return (
    <Modal title={title} onClose={closeModal}>
      <p>{text}</p>
    </Modal>
  )
}
